import { DataCellProps } from '../../types';
import { format, parseISO } from 'date-fns';

const MostRecentUpdateDataCell = ({ _customRowProps, mostrecentupdate }: DataCellProps) => {
  return <div>{format(parseISO(mostrecentupdate), 'P, h:mm:ss a')}</div>;
};

export default MostRecentUpdateDataCell;
